// src/components/DateRangePicker.js
import React, { useState } from 'react';

function toDateStr(d) { return d.toISOString().slice(0, 10); }

function presetRange(key) {
  const today = new Date();
  const end = toDateStr(today);
  if (key === 'today') return { startDate: end, endDate: end };
  if (key === 'last7') {
    const s = new Date(today); s.setDate(s.getDate() - 6);
    return { startDate: toDateStr(s), endDate: end };
  }
  if (key === 'last30') {
    const s = new Date(today); s.setDate(s.getDate() - 29);
    return { startDate: toDateStr(s), endDate: end };
  }
  if (key === 'thisMonth') {
    const s = new Date(today.getFullYear(), today.getMonth(), 1);
    return { startDate: toDateStr(s), endDate: end };
  }
  if (key === 'lastMonth') {
    const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const e = new Date(today.getFullYear(), today.getMonth(), 0);
    return { startDate: toDateStr(s), endDate: toDateStr(e) };
  }
  return { startDate: end, endDate: end };
}

export default function DateRangePicker({ startDate, endDate, onChange, presets = true }) {
  const [localStart, setLocalStart] = useState(startDate);
  const [localEnd, setLocalEnd]     = useState(endDate);

  const apply = (s = localStart, e = localEnd) => {
    setLocalStart(s); setLocalEnd(e);
    onChange({ startDate: s, endDate: e });
  };

  const applyPreset = (key) => {
    const r = presetRange(key);
    apply(r.startDate, r.endDate);
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
      <input
        type="date"
        value={localStart}
        onChange={(e) => setLocalStart(e.target.value)}
        className="input"
        style={{ width: 150 }}
      />
      <span>to</span>
      <input
        type="date"
        value={localEnd}
        onChange={(e) => setLocalEnd(e.target.value)}
        className="input"
        style={{ width: 150 }}
      />
      <button className="btn btn-sm" onClick={() => apply()}>Apply</button>
      {presets && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button className="btn btn-ghost btn-sm" onClick={() => applyPreset('today')}>Today</button>
          <button className="btn btn-ghost btn-sm" onClick={() => applyPreset('last7')}>Last 7 days</button>
          <button className="btn btn-ghost btn-sm" onClick={() => applyPreset('last30')}>Last 30 days</button>
          <button className="btn btn-ghost btn-sm" onClick={() => applyPreset('thisMonth')}>This month</button>
          <button className="btn btn-ghost btn-sm" onClick={() => applyPreset('lastMonth')}>Last month</button>
        </div>
      )}
    </div>
  );
}
